document.documentElement.classList.remove('no-js');

const $ = (selector, context = document) => context.querySelector(selector);
const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];
const currency = document.body?.dataset.currency || 'GBP';
const money = (cents) => new Intl.NumberFormat('en-GB', { style: 'currency', currency }).format(Number(cents || 0) / 100);

function openDrawer(element) {
  if (!element) return;
  element.classList.add('is-open');
  element.setAttribute('aria-hidden', 'false');
  document.body.classList.add('drawer-open');
}

function closeDrawer(element) {
  if (!element) return;
  element.classList.remove('is-open');
  element.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('drawer-open');
}

const mobileMenu = $('[data-mobile-menu]');
$('[data-mobile-menu-open]')?.addEventListener('click', (event) => {
  openDrawer(mobileMenu);
  event.currentTarget.setAttribute('aria-expanded', 'true');
});
$('[data-mobile-menu-close]')?.addEventListener('click', () => {
  closeDrawer(mobileMenu);
  $('[data-mobile-menu-open]')?.setAttribute('aria-expanded', 'false');
});

const searchDrawer = $('[data-search-drawer]');
$('[data-search-open]')?.addEventListener('click', (event) => {
  searchDrawer?.showModal();
  event.currentTarget.setAttribute('aria-expanded', 'true');
  setTimeout(() => $('[data-predictive-search-input]')?.focus(), 50);
});
$('[data-search-close]')?.addEventListener('click', () => {
  searchDrawer?.close();
  $('[data-search-open]')?.setAttribute('aria-expanded', 'false');
});
searchDrawer?.addEventListener('click', (event) => {
  if (event.target === searchDrawer) searchDrawer.close();
});

let searchTimer;
$('[data-predictive-search-input]')?.addEventListener('input', (event) => {
  clearTimeout(searchTimer);
  const query = event.target.value.trim();
  const target = $('[data-predictive-results]');
  if (query.length < 2) {
    if (target) target.innerHTML = '';
    return;
  }
  searchTimer = setTimeout(async () => {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`);
      const data = await response.json();
      const products = data.resources?.results?.products || [];
      if (!target) return;
      target.innerHTML = products.length
        ? `<div class="predictive-grid">${products.map((product) => `
          <a href="${product.url}" class="predictive-item">
            ${product.image ? `<img src="${product.image}" alt="">` : ''}
            <span><small>${product.vendor || 'Fancy Fashions'}</small><strong>${product.title}</strong><em>${product.price}</em></span>
          </a>`).join('')}</div><a class="text-link" href="${root}search?q=${encodeURIComponent(query)}">View all results ↗</a>`
        : '<p class="empty-state">No matching pieces found.</p>';
    } catch (error) {
      if (target) target.innerHTML = '<p class="empty-state">Search is temporarily unavailable.</p>';
    }
  }, 250);
});

class QuantityInput extends HTMLElement {
  connectedCallback() {
    const input = $('input', this);
    $$('button', this).forEach((button) => button.addEventListener('click', () => {
      const step = button.name === 'plus' ? 1 : -1;
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  }
}
if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);

function showToast(message) {
  const toast = $('[data-cart-toast]');
  if (!toast) return;
  toast.textContent = message;
  toast.hidden = false;
  toast.classList.add('is-visible');
  setTimeout(() => { toast.classList.remove('is-visible'); toast.hidden = true; }, 2800);
}

const FREE_DELIVERY_TARGET = 9900;
const cartDrawer = $('[data-cart-drawer]');
const cartDrawerPanel = $('[data-cart-drawer-panel]');

const escapeHtml = (value = '') => String(value).replace(/[&<>"]/g, (character) => ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;'
}[character]));

function closeCartDrawer() {
  if (!cartDrawer) return;
  cartDrawer.classList.remove('is-open');
  cartDrawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('drawer-open');
}

function openCartDrawer() {
  if (!cartDrawer) return;
  cartDrawer.hidden = false;
  requestAnimationFrame(() => {
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    $('[data-cart-drawer-close]', cartDrawer)?.focus();
  });
}

function renderCartDrawer(cart) {
  if (!cartDrawer) return;

  const remaining = Math.max(FREE_DELIVERY_TARGET - cart.total_price, 0);
  const progress = Math.min((cart.total_price / FREE_DELIVERY_TARGET) * 100, 100);
  const progressText = remaining > 0
    ? `You're <strong>${money(remaining)}</strong> away from FREE UK delivery`
    : '<strong>You’ve unlocked FREE UK delivery!</strong>';

  const message = $('[data-free-delivery-message]', cartDrawer);
  const bar = $('[data-free-delivery-bar]', cartDrawer);
  const items = $('[data-cart-drawer-items]', cartDrawer);
  const subtotal = $('[data-cart-drawer-subtotal]', cartDrawer);
  const count = $('[data-cart-drawer-count]', cartDrawer);
  const footer = $('[data-cart-drawer-footer]', cartDrawer);

  if (message) message.innerHTML = progressText;
  if (bar) {
    bar.style.width = `${progress}%`;
    bar.parentElement?.setAttribute('aria-valuenow', String(Math.round(progress)));
  }
  if (subtotal) subtotal.textContent = money(cart.total_price);
  if (count) count.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`;

  if (!items) return;
  if (!cart.items.length) {
    items.innerHTML = '<div class="cart-drawer__empty"><p>Your bag is empty.</p><button type="button" class="text-link" data-cart-drawer-close>Continue shopping</button></div>';
    if (footer) footer.hidden = true;
    return;
  }

  if (footer) footer.hidden = false;
  items.innerHTML = cart.items.map((item) => {
    const imageUrl = item.featured_image?.url
      ? `${item.featured_image.url}${item.featured_image.url.includes('?') ? '&' : '?'}width=240`
      : '';
    const image = imageUrl
      ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(item.featured_image.alt || item.product_title)}" loading="lazy">`
      : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<p>${escapeHtml(item.variant_title)}</p>`
      : '';
    const properties = Object.entries(item.properties || {})
      .filter(([name, value]) => name.charAt(0) !== '_' && value)
      .map(([name, value]) => `<p>${escapeHtml(name)}: ${escapeHtml(value)}</p>`)
      .join('');

    return `<article class="cart-drawer-item">
      <a class="cart-drawer-item__image" href="${escapeHtml(item.url)}">${image}</a>
      <div class="cart-drawer-item__details">
        <a class="cart-drawer-item__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
        ${variant}
        ${properties}
        <strong>${money(item.final_line_price)}</strong>
        <div class="cart-drawer-item__actions">
          <div class="cart-drawer-quantity" aria-label="Quantity">
            <button type="button" data-cart-quantity="${escapeHtml(item.key)}" data-quantity="${Math.max(item.quantity - 1, 0)}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-quantity="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
          </div>
          <button type="button" class="cart-drawer-item__remove" data-cart-quantity="${escapeHtml(item.key)}" data-quantity="0">Remove</button>
        </div>
      </div>
    </article>`;
  }).join('');
}

async function getCart() {
  return fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
    headers: { Accept: 'application/json' }
  }).then((response) => response.json());
}

async function updateCartItem(key, quantity) {
  cartDrawerPanel?.classList.add('is-loading');
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!response.ok) throw await response.json();
    const cart = await response.json();
    $$('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    renderCartDrawer(cart);
  } catch (error) {
    showToast(error.description || 'Your bag could not be updated. Please try again.');
  } finally {
    cartDrawerPanel?.classList.remove('is-loading');
  }
}

cartDrawer?.addEventListener('click', (event) => {
  if (event.target.closest('[data-cart-drawer-close]') || event.target.matches('[data-cart-drawer-overlay]')) {
    closeCartDrawer();
    return;
  }
  const quantityButton = event.target.closest('[data-cart-quantity]');
  if (quantityButton) updateCartItem(quantityButton.dataset.cartQuantity, Number(quantityButton.dataset.quantity));
});

$$('[data-cart-link]').forEach((link) => link.addEventListener('click', async (event) => {
  if (!cartDrawer) return;
  event.preventDefault();
  renderCartDrawer(await getCart());
  openCartDrawer();
}));

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && cartDrawer?.classList.contains('is-open')) closeCartDrawer();
});

async function addToCart(form) {
  const section = form.closest('[data-product-section]');
  const buttons = section ? $$('[data-add-to-cart], [data-add-to-cart-mobile]', section) : [$('button[type="submit"]', form)].filter(Boolean);
  const originals = buttons.map((button) => button.innerHTML);
  buttons.forEach((button) => { button.disabled = true; button.textContent = 'Adding…'; });
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw await response.json();
    await response.json();
    const cart = await getCart();
    $$('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
    renderCartDrawer(cart);
    openCartDrawer();
  } catch (error) {
    const errorTarget = $('[data-product-form-errors]', form.parentElement) || $('[data-product-form-errors]');
    if (errorTarget) errorTarget.textContent = error.description || 'This piece could not be added. Please try again.';
    else showToast(error.description || 'Unable to add this piece.');
  } finally {
    buttons.forEach((button, index) => { button.disabled = false; button.innerHTML = originals[index]; });
  }
}

$$('[data-quick-add]').forEach((form) => form.addEventListener('submit', (event) => { event.preventDefault(); addToCart(form); }));

$$('[data-product-section]').forEach((section) => {
  const variants = JSON.parse($('[data-variant-json]', section)?.textContent || '[]');
  const selects = $$('[data-option-select]', section);
  const optionButtons = $$('[data-option-button]', section);
  const form = $('[data-product-form]', section);
  const variantInput = $('[data-variant-id]', section);
  const addButtons = $$('[data-add-to-cart], [data-add-to-cart-mobile]', section);
  const addTexts = $$('[data-add-to-cart-text]', section);
  const addPrices = $$('[data-add-to-cart-price]', section);
  const availability = $('[data-availability]', section);
  const price = $('[data-product-price]', section);
  const compare = $('[data-compare-price]', section);
  const mobilePrice = $('[data-mobile-price]', section);
  const mobileVariant = $('[data-mobile-variant]', section);

  const updateSizeAvailability = (selectedValues = selects.map((select) => select.value)) => {
    optionButtons.forEach((button) => {
      const optionName = (button.dataset.optionName || '').toLowerCase();
      if (!optionName.includes('size')) return;

      const optionIndex = Number(button.dataset.optionIndex);
      const optionValue = button.dataset.optionValue;
      const hasAvailableVariant = variants.some((variant) => (
        variant.available
        && variant.options[optionIndex] === optionValue
        && variant.options.every((value, index) => index === optionIndex || value === selectedValues[index])
      ));

      button.disabled = !hasAvailableVariant;
      button.classList.toggle('is-unavailable', !hasAvailableVariant);
      button.setAttribute('aria-disabled', String(!hasAvailableVariant));
      button.setAttribute('aria-label', hasAvailableVariant ? optionValue : `${optionValue} — sold out`);
    });
  };

  const selectVariant = () => {
    const selected = selects.map((select) => select.value);
    updateSizeAvailability(selected);
    const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
    if (!variant) {
      addButtons.forEach((button) => { button.disabled = true; });
      addTexts.forEach((text) => { text.textContent = 'Unavailable'; });
      return;
    }
    if (variantInput) variantInput.value = variant.id;
    if (price) price.textContent = money(variant.price);
    if (compare) compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
    if (mobilePrice) mobilePrice.textContent = money(variant.price);
    if (mobileVariant) mobileVariant.textContent = variant.title;
    addPrices.forEach((node) => { node.textContent = money(variant.price); });
    addButtons.forEach((button) => { button.disabled = !variant.available; });
    addTexts.forEach((text) => { text.textContent = variant.available ? 'Add to bag' : 'Sold out'; });
    if (availability) availability.innerHTML = variant.available ? '<span></span> In stock and ready to dispatch' : 'Currently unavailable';
    optionButtons.forEach((button) => {
      const selectedValue = selected[Number(button.dataset.optionIndex)];
      const isSelected = button.dataset.optionValue === selectedValue;
      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-pressed', String(isSelected));
    });
    if (variant.featured_media?.id) $(`[data-media-target="${variant.featured_media.id}"]`, section)?.click();
    history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
  };
  selects.forEach((select) => select.addEventListener('change', selectVariant));
  optionButtons.forEach((button) => button.addEventListener('click', () => {
    const select = selects[Number(button.dataset.optionIndex)];
    if (!select) return;
    select.value = button.dataset.optionValue;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  updateSizeAvailability();
  form?.addEventListener('submit', (event) => { event.preventDefault(); addToCart(form); });

  $$('[data-media-target]', section).forEach((button) => button.addEventListener('click', () => {
    $$('[data-media-id]', section).forEach((media) => media.classList.toggle('is-hidden', media.dataset.mediaId !== button.dataset.mediaTarget));
    $$('[data-media-target]', section).forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
  }));

  const sizeModal = $('[data-size-guide-modal]', section);
  const hydrateProductSizeGuide = () => {
    const target = $('[data-size-guide-product-content]', sizeModal);
    if (!target || target.dataset.hydrated === 'true') return;
    target.dataset.hydrated = 'true';

    const descriptionImages = $$('.product-accordions--editorial .rte img', section);
    const galleryImages = $$('[data-product-gallery] img', section);
    const images = [...descriptionImages, ...galleryImages];
    const chartPattern = /(size[\s_-]*(chart|guide)|measurement[\s_-]*(chart|guide)?)/i;
    let chartImage = images.find((image) => chartPattern.test(`${image.alt || ''} ${image.currentSrc || image.src || ''}`));
    if (!chartImage && descriptionImages.length === 1) chartImage = descriptionImages[0];
    if (!chartImage) return;

    const clone = chartImage.cloneNode(false);
    clone.loading = 'eager';
    clone.removeAttribute('width');
    clone.removeAttribute('height');
    clone.alt = clone.alt || `Size chart for ${document.querySelector('h1')?.textContent?.trim() || 'this product'}`;
    target.replaceChildren(clone);
    target.hidden = false;
    $('[data-size-guide-theme-fallback]', sizeModal)?.setAttribute('hidden', '');
  };
  $$('[data-size-guide-open]', section).forEach((button) => button.addEventListener('click', () => {
    if (!sizeModal) return;
    hydrateProductSizeGuide();
    if (typeof sizeModal.showModal === 'function') sizeModal.showModal();
    else sizeModal.setAttribute('open', '');
  }));
  $('[data-size-guide-close]', section)?.addEventListener('click', () => {
    if (typeof sizeModal?.close === 'function') sizeModal.close();
    else sizeModal?.removeAttribute('open');
  });
  sizeModal?.addEventListener('click', (event) => {
    if (event.target !== sizeModal) return;
    if (typeof sizeModal.close === 'function') sizeModal.close();
    else sizeModal.removeAttribute('open');
  });

  const lightbox = $('[data-product-lightbox]', section);
  const lightboxSlides = $$('[data-product-lightbox-slide]', section);
  const lightboxCounter = $('[data-product-lightbox-counter]', section);
  let activeLightboxSlide = 0;
  const showLightboxSlide = (index) => {
    if (!lightboxSlides.length) return;
    activeLightboxSlide = (index + lightboxSlides.length) % lightboxSlides.length;
    lightboxSlides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== activeLightboxSlide; });
    if (lightboxCounter) lightboxCounter.textContent = `${activeLightboxSlide + 1} / ${lightboxSlides.length}`;
  };
  $$('[data-product-lightbox-open]', section).forEach((button) => button.addEventListener('click', () => {
    showLightboxSlide(Number(button.dataset.productLightboxOpen));
    lightbox?.showModal();
  }));
  $('[data-product-lightbox-close]', section)?.addEventListener('click', () => lightbox?.close());
  $('[data-product-lightbox-previous]', section)?.addEventListener('click', () => showLightboxSlide(activeLightboxSlide - 1));
  $('[data-product-lightbox-next]', section)?.addEventListener('click', () => showLightboxSlide(activeLightboxSlide + 1));
  lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) lightbox.close(); });
  lightbox?.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') showLightboxSlide(activeLightboxSlide - 1);
    if (event.key === 'ArrowRight') showLightboxSlide(activeLightboxSlide + 1);
  });
});

$$('product-recommendations').forEach(async (element) => {
  if (!element.dataset.url) return;
  const html = await fetch(element.dataset.url).then((response) => response.text()).catch(() => '');
  if (!html) return;
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  const replacement = parsed.querySelector('product-recommendations');
  if (replacement?.innerHTML.trim()) element.innerHTML = replacement.innerHTML;
});

const filterDrawer = $('[data-filter-drawer]');
$('[data-filter-open]')?.addEventListener('click', () => openDrawer(filterDrawer));
$('[data-filter-close]')?.addEventListener('click', () => closeDrawer(filterDrawer));
$('[data-sort-select]')?.addEventListener('change', (event) => event.target.form?.submit());
